"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFileInputTypesLabel = exports.StyledFileInputText = exports.StyledFileInputRequired = exports.StyledFileInputObject = exports.StyledFileInputLabel = exports.StyledFileInputError = exports.StyledFileInputContainer = exports.StyledFileInputChooseButton = exports.StyledAlertIconContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledFileInputError = _styledComponents["default"].div.withConfig({
  displayName: "FileInputstyles__StyledFileInputError",
  componentId: "sc-yxunkz-0"
})(["", " font-size:", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["sans-serif w-100 pt1\n    ", "\n  "])), function (props) {
  return props.theme.textInput.errorColor;
}), function (props) {
  return props.theme.textInput.errorMessageFontSize || '0.875rem';
});

exports.StyledFileInputError = StyledFileInputError;

var StyledFileInputContainer = _styledComponents["default"].div.withConfig({
  displayName: "FileInputstyles__StyledFileInputContainer",
  componentId: "sc-yxunkz-1"
})(["", " border-width:", ";box-sizing:border-box;&.error{", " label{", "}}"], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    w-100 relative\n    ", "\n    ", "\n  "])), function (props) {
  return props.theme.textInput.borderRadius;
}, function (_ref) {
  var focus = _ref.focus,
      readOnly = _ref.readOnly,
      theme = _ref.theme;
  return focus && !readOnly ? theme.textInput.borderColorFocus : theme.textInput.borderColor;
}), function (props) {
  return props.theme.textInput.borderWidth;
}, (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (props) {
  return "b--".concat(props.theme.textInput.errorColor);
}), (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (props) {
  return "b--".concat(props.theme.textInput.errorColor);
}));

exports.StyledFileInputContainer = StyledFileInputContainer;

var StyledFileInputObject = _styledComponents["default"].input.withConfig({
  displayName: "FileInputstyles__StyledFileInputObject",
  componentId: "sc-yxunkz-2"
})(["", ""], (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["dn"]))));

exports.StyledFileInputObject = StyledFileInputObject;

var StyledFileInputLabel = _styledComponents["default"].label.withConfig({
  displayName: "FileInputstyles__StyledFileInputLabel",
  componentId: "sc-yxunkz-3"
})(["", " font-size:", ";", " align-items:center;cursor:text;transition:all 0.15s ease;text-align:left;"], (0, _ty["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n    dib ma0 pa0 border-box top-0 left-0 lh-solid mb2 mr2 b\n    ", "\n  "])), function (_ref2) {
  var disabled = _ref2.disabled,
      theme = _ref2.theme;
  return disabled ? theme.textInput.disabledLabel : theme.textInput.label;
}), function (_ref3) {
  var formComponents = _ref3.theme.formComponents;
  return formComponents === null || formComponents === void 0 ? void 0 : formComponents.fontSize.label;
}, function (_ref4) {
  var formComponents = _ref4.theme.formComponents;
  return (0, _styledComponents.css)(["font-size:", ";"], formComponents === null || formComponents === void 0 ? void 0 : formComponents.fontSize.label);
});

exports.StyledFileInputLabel = StyledFileInputLabel;

var StyledFileInputTypesLabel = _styledComponents["default"].label.withConfig({
  displayName: "FileInputstyles__StyledFileInputTypesLabel",
  componentId: "sc-yxunkz-4"
})(["", " font-size:", ";", " align-items:center;cursor:text;transition:all 0.15s ease;text-align:left;"], (0, _ty["default"])(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n    dib ma0 pa0 border-box top-0 left-0 lh-solid mb2\n    ", "\n  "])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.textInput.secondarylabel;
}), function (_ref6) {
  var formComponents = _ref6.theme.formComponents;
  return formComponents === null || formComponents === void 0 ? void 0 : formComponents.fontSize.label;
}, function (_ref7) {
  var formComponents = _ref7.theme.formComponents;
  return (0, _styledComponents.css)(["font-size:", ";"], formComponents === null || formComponents === void 0 ? void 0 : formComponents.fontSize.label);
});

exports.StyledFileInputTypesLabel = StyledFileInputTypesLabel;

var StyledFileInputText = _styledComponents["default"].label.withConfig({
  displayName: "FileInputstyles__StyledFileInputText",
  componentId: "sc-yxunkz-5"
})(["&&{", " ", " font-size:", ";border-width:", ";box-sizing:border-box;text-indent:3px;cursor:pointer;", " ", " text-indent:0.5rem;:focus{outline:none;}}"], (0, _ty["default"])(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n      dib w-100 h-100 pl1 sans-serif ba\n      ", "\n      ", "\n      ", "\n      ", "\n    "])), function (_ref8) {
  var filled = _ref8.filled,
      theme = _ref8.theme;
  return !filled ? theme.textInput.disabledLabel : '';
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.textInput.backgroundColor || 'bg-transparent';
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.textInput.borderRadius;
}, function (_ref11) {
  var disabled = _ref11.disabled,
      theme = _ref11.theme;
  return disabled && "bg-".concat(theme.textInput.disabledBackground, " ").concat(theme.textInput.disabledText || theme.textInput.disabledLabel);
}), function (_ref12) {
  var _formComponents$input;

  var formComponents = _ref12.theme.formComponents;
  return (0, _styledComponents.css)(["height:", ";"], formComponents === null || formComponents === void 0 ? void 0 : (_formComponents$input = formComponents.inputDropdownHeight) === null || _formComponents$input === void 0 ? void 0 : _formComponents$input.normal);
}, function (_ref13) {
  var formComponents = _ref13.theme.formComponents;
  return formComponents === null || formComponents === void 0 ? void 0 : formComponents.fontSize.input;
}, function (props) {
  return props.theme.textInput.borderWidth;
}, function (_ref14) {
  var disabled = _ref14.disabled;
  return disabled && 'cursor: not-allowed;';
}, function (_ref15) {
  var theme = _ref15.theme;
  return (0, _styledComponents.css)(["padding:0.625rem 0;", " :focus:not(:read-only){", "}"], (0, _ty["default"])(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["", ""])), theme.textInput.borderColor), (0, _ty["default"])(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["", ""])), theme.textInput.borderColorFocus));
});

exports.StyledFileInputText = StyledFileInputText;

var StyledFileInputChooseButton = _styledComponents["default"].span.withConfig({
  displayName: "FileInputstyles__StyledFileInputChooseButton",
  componentId: "sc-yxunkz-6"
})(["", ""], (0, _ty["default"])(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n    pr2\n    ", "\n  "])), function (_ref16) {
  var theme = _ref16.theme;
  return theme.link.types.anchor["default"];
}));

exports.StyledFileInputChooseButton = StyledFileInputChooseButton;

var StyledFileInputRequired = _styledComponents["default"].span.withConfig({
  displayName: "FileInputstyles__StyledFileInputRequired",
  componentId: "sc-yxunkz-7"
})(["", " text-indent:0.15rem;"], (0, _ty["default"])(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "])), function (_ref17) {
  var disabled = _ref17.disabled,
      theme = _ref17.theme;
  return disabled ? theme.textInput.disabledLabel : 'red';
}));

exports.StyledFileInputRequired = StyledFileInputRequired;

var StyledAlertIconContainer = _styledComponents["default"].div.withConfig({
  displayName: "FileInputstyles__StyledAlertIconContainer",
  componentId: "sc-yxunkz-8"
})(["", " width:1.5rem;top:2.1rem;right:0.6rem;& > svg{", " width:100%;height:100%;}"], (0, _ty["default"])(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2["default"])(["nl1 absolute"]))), function (props) {
  return "\n      stroke: var(--".concat(props.theme.textInput.errorColor, ");\n      fill: var(--").concat(props.theme.textInput.errorColor, ");\n    ");
});

exports.StyledAlertIconContainer = StyledAlertIconContainer;